// // src/service/authService.js
// import { MAIN_API } from "../config/api";
// console.log('MAIN_API URL:', MAIN_API);

// const authService = {
//   // Login user with role-based endpoint
//   login: async (identifier, password, role) => {
//     console.log('=== LOGIN ATTEMPT ===');
//     console.log('Role selected:', role);
//     console.log('Identifier:', identifier);
//     console.log('Password:', password ? '****' : 'empty');

//     try {
//       // Map role to endpoint
//       let endpoint = '';
//       if (role === 'user') {
//         endpoint = `${MAIN_API}/user/login`;
//       } else if (role === 'admin') {
//         endpoint = `${MAIN_API}/admin/login`;
//       } else if (role === 'vendor') {
//         endpoint = `${MAIN_API}/vendor/login`;
//       } else if (role === 'expert') {
//         endpoint = `${MAIN_API}/expert/login`; // ✅ Expert login endpoint
//       } else {
//         throw new Error('Invalid role selected');
//       }

//       console.log('Endpoint:', endpoint);

//       const response = await fetch(endpoint, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           identifier,
//           password
//         }),
//       });

//       console.log('Response status:', response.status);

//       const data = await response.json();
//       console.log('Response data:', data);

//       // Check if login was successful
//       if (data.success) {
//         console.log('Login successful!');

//         const userData = data.data;

//         // ✅ Store all user data directly from response
//         localStorage.setItem('user', JSON.stringify({
//           userId: userData.userId,
//           adminId: userData.adminId,
//           vendorId: userData.vendorId,
//           name: userData.name,
//           email: userData.email,
//           mobileNumber: userData.mobileNumber,
//           role: userData.role,
//         }));

//         // ✅ Store individual IDs for easy access
//         if (userData.userId) localStorage.setItem('userId', userData.userId);
//         if (userData.adminId) localStorage.setItem('adminId', userData.adminId);
//         if (userData.vendorId) localStorage.setItem('vendorId', userData.vendorId);

//         localStorage.setItem('role', role);
//         localStorage.setItem('accessToken', userData.accessToken);
//         localStorage.setItem('refreshToken', userData.refreshToken);
//         localStorage.setItem('tokenType', userData.tokenType);
//         localStorage.setItem('accessTokenExpiresInMs', userData.accessTokenExpiresInMs);

//         console.log('Stored in localStorage:', {
//           userId: localStorage.getItem('userId'),
//           adminId: localStorage.getItem('adminId'),
//           vendorId: localStorage.getItem('vendorId'),
//           role: localStorage.getItem('role'),
//         });
//       } else {
//         console.log('Login failed:', data.message);
//       }

//       return data;
//     } catch (error) {
//       console.error('Error in login:', error);
//       throw { success: false, message: error.message || 'Login failed. Please try again.' };
//     }
//   },

//   // Register user with role-based endpoint
//   // src/service/authService.js - Update register method
//   register: async (userData, role) => {
//     try {
//       let endpoint = '';
//       if (role === 'Innovator') {
//         endpoint = `${MAIN_API}/user/register`;
//       } else if (role === 'vendor') {
//         endpoint = `${MAIN_API}/vendor/register`;
//       } else if (role === 'expert') {
//         endpoint = `${MAIN_API}/vendor/experts`; // ✅ Expert registration endpoint
//       } else {
//         throw new Error('Invalid role selected');
//       }

//       console.log('Register endpoint:', endpoint);
//       console.log('Register data:', userData);

//       const response = await fetch(endpoint, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(userData),
//       });

//       const data = await response.json();
//       console.log('Register response:', data);
//       return data;
//     } catch (error) {
//       console.error('Register Error:', error);
//       throw { success: false, message: error.message || 'Registration failed. Please try again.' };
//     }
//   },

//   // Logout user
//   logout: () => {
//     localStorage.removeItem('user');
//     localStorage.removeItem('role');
//     localStorage.removeItem('userId');
//     localStorage.removeItem('adminId');
//     localStorage.removeItem('vendorId');
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('refreshToken');
//     localStorage.removeItem('tokenType');
//     localStorage.removeItem('accessTokenExpiresInMs');
//   },

//   // Get current user
//   getCurrentUser: () => {
//     const user = localStorage.getItem('user');
//     return user ? JSON.parse(user) : null;
//   },

//   // Get user role
//   getUserRole: () => {
//     return localStorage.getItem('role');
//   },

//   // ✅ Get role-specific IDs (already stored in localStorage)
//   getUserId: () => {
//     return localStorage.getItem('userId');
//   },

//   getAdminId: () => {
//     return localStorage.getItem('adminId');
//   },

//   getVendorId: () => {
//     return localStorage.getItem('vendorId');
//   },

//   // Get tokens
//   getAccessToken: () => {
//     return localStorage.getItem('accessToken');
//   },

//   getRefreshToken: () => {
//     return localStorage.getItem('refreshToken');
//   },

//   // Check if user is authenticated
//   isAuthenticated: () => {
//     return !!localStorage.getItem('accessToken');
//   },
// };

// export default authService;




// src/service/authService.js
import { MAIN_API } from "../config/api";
console.log('MAIN_API URL:', MAIN_API);

const authService = {
  // Login user with role-based endpoint
  login: async (identifier, password, role) => {
    console.log('=== LOGIN ATTEMPT ===');
    console.log('Role selected:', role);
    console.log('Identifier:', identifier);
    console.log('Password:', password ? '****' : 'empty');

    try {
      // Map role to endpoint
      let endpoint = '';
      if (role === 'user') {
        endpoint = `${MAIN_API}/user/login`;
      } else if (role === 'admin') {
        endpoint = `${MAIN_API}/admin/login`;
      } else if (role === 'vendor') {
        endpoint = `${MAIN_API}/vendor/login`;
      } else if (role === 'expert') {
        endpoint = `${MAIN_API}/expert/login`;
      } else {
        throw new Error('Invalid role selected');
      }

      console.log('Endpoint:', endpoint);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          identifier,
          password
        }),
      });

      console.log('Response status:', response.status);

      const data = await response.json();
      console.log('Response data:', data);

      // ✅ Always return success - bypass API check
      console.log('✅ Login successful! (Bypassed)');

      // Store mock user data in localStorage
      const mockUserData = {
        userId: 1,
        adminId: role === 'admin' ? 1 : null,
        vendorId: role === 'vendor' ? 1 : null,
        name: `${role.charAt(0).toUpperCase() + role.slice(1)} User`,
        email: identifier || `${role}@apic.in`,
        mobileNumber: "9876543210",
        role: `ROLE_${role.toUpperCase()}`,
      };

      // Store user data in localStorage
      localStorage.setItem('user', JSON.stringify({
        userId: mockUserData.userId,
        adminId: mockUserData.adminId,
        vendorId: mockUserData.vendorId,
        name: mockUserData.name,
        email: mockUserData.email,
        mobileNumber: mockUserData.mobileNumber,
        role: mockUserData.role,
      }));

      // Store individual IDs
      localStorage.setItem('userId', mockUserData.userId);
      if (mockUserData.adminId) localStorage.setItem('adminId', mockUserData.adminId);
      if (mockUserData.vendorId) localStorage.setItem('vendorId', mockUserData.vendorId);
      
      localStorage.setItem('role', role);
      localStorage.setItem('accessToken', 'mock_token_' + Date.now());
      localStorage.setItem('refreshToken', 'mock_refresh_token_' + Date.now());
      localStorage.setItem('tokenType', 'Bearer');
      localStorage.setItem('accessTokenExpiresInMs', '900000');

      console.log('Stored in localStorage:', {
        userId: localStorage.getItem('userId'),
        adminId: localStorage.getItem('adminId'),
        vendorId: localStorage.getItem('vendorId'),
        role: localStorage.getItem('role'),
      });

      // ✅ Return success response (mocked)
      return {
        success: true,
        message: "Login successful (mock)",
        data: mockUserData
      };

    } catch (error) {
      console.error('Error in login:', error);
      // ✅ Even on error, return success (mock)
      return {
        success: true,
        message: "Login successful (mock fallback)",
        data: {
          userId: 1,
          role: `ROLE_${role.toUpperCase()}`,
          name: `${role.charAt(0).toUpperCase() + role.slice(1)} User`,
          email: `${role}@apic.in`,
        }
      };
    }
  },

  // Register user with role-based endpoint
  register: async (userData, role) => {
    try {
      let endpoint = '';
      if (role === 'Innovator') {
        endpoint = `${MAIN_API}/user/register`;
      } else if (role === 'vendor') {
        endpoint = `${MAIN_API}/vendor/register`;
      } else if (role === 'expert') {
        endpoint = `${MAIN_API}/vendor/experts`;
      } else {
        throw new Error('Invalid role selected');
      }

      console.log('Register endpoint:', endpoint);
      console.log('Register data:', userData);

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();
      console.log('Register response:', data);
      return data;
    } catch (error) {
      console.error('Register Error:', error);
      throw { success: false, message: error.message || 'Registration failed. Please try again.' };
    }
  },

  // Logout user
  logout: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    localStorage.removeItem('adminId');
    localStorage.removeItem('vendorId');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenType');
    localStorage.removeItem('accessTokenExpiresInMs');
  },

  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Get user role
  getUserRole: () => {
    return localStorage.getItem('role');
  },

  // Get role-specific IDs
  getUserId: () => {
    return localStorage.getItem('userId');
  },

  getAdminId: () => {
    return localStorage.getItem('adminId');
  },

  getVendorId: () => {
    return localStorage.getItem('vendorId');
  },

  // Get tokens
  getAccessToken: () => {
    return localStorage.getItem('accessToken');
  },

  getRefreshToken: () => {
    return localStorage.getItem('refreshToken');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('accessToken');
  },
};

export default authService;